<template>
  <!-- 任务提交意见反馈弹窗 -->
  <a-modal :visible="feedbackVisible" title="请提交意见" @cancel="handleCancel">
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取消 </a-button>
      <a-button
        key="submit"
        type="primary"
        @click="handleOk"
      >
        提交
      </a-button>
    </template>
    <div class="rate" v-if="workStatus == 9">
      时间要求：用户申领后，须在
      <a-input v-model="completionDays" style="width: 50px;" :maxLength="5"/>
      日完成
    </div>
    <div class="rate" v-if="workStatus == 9">
      倒计时天数提醒：完成前
      <a-input v-model="reminderDays" style="width: 50px;" :maxLength="5"/>
      日开始提醒
    </div>
    <div v-if="workStatus == 7">
      <div class="rate">
        本次任务已通过，请评分：<a-rate v-model="grade"/>
      </div>
      <div class="rate">
        注：通过实际质量来给出评价，最低为三星，三星75%，四星100%，五星120%，其中五星和三星都需要填评价理由。
      </div>
    </div>
    
    <a-form
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
    >
      <a-form-item class="feedback">
        <a-textarea
          placeholder="请输入提交意见"
          v-model="value"
          :auto-size="{ minRows: 10, maxRows: 10 }"
          :maxlength="500"
        />
      </a-form-item>
    </a-form>

    <div v-if="workStatus == 7">
      <div class="rate-grade">
        <span>你的评分是：{{grade}}星</span>
        <span v-if="grade == 1 || grade == 2">积分和报酬可获比例：{{grade * 20}}%</span>
        <span v-else>积分和报酬可获比例：{{grade == 3 ? 75 : grade == 4 ? 100 : grade == 5 ? 120 : ''}}%</span>
      </div>
    </div>
  </a-modal>
</template>
<script>

export default {
  props: ['feedbackVisible', 'workStatus'],
  data() {
    return {
      value: '',
      grade: 3,
      completionDays: 0,
      reminderDays: 0
    };
  },
  methods: {
    async handleOk() {
      if ((!this.value && this.workStatus != 7) || this.workStatus == 7 && (this.grade == 3 || this.grade == 5) && !this.value) {
        return this.$message.warning('请先输入内容')
      }

      this.$emit('handleOk', {
        content: this.value,
        grade: this.grade, // 通过需要
        reminderDays: this.reminderDays, // 返修需要
        completionDays: this.completionDays // 返修需要
      })
      this.value = ''
      this.grade = 3
    },
    handleCancel() {
      this.value = ''
      this.$emit('handleClose')
    }
  }
};
</script>
<style>
.rate {
  margin-bottom: 10px;
}

.rate-grade {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;  
}
</style>